import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgSelectConfig } from '@ng-select/ng-select';
import Aos from 'aos';
import { NgxSonnerToaster } from 'ngx-sonner';

import { LoadingService } from '@platform/shared/services/utils/loading.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgxSonnerToaster],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    .app-loading-track {
      position: fixed;
      inset: 0 0 auto 0;
      z-index: 100000;
      height: 3px;
      overflow: hidden;
      pointer-events: none;
      background: rgb(244 244 245 / 0.85);
    }

    .app-loading-bar {
      position: absolute;
      top: 0;
      bottom: 0;
      width: 32%;
      border-radius: 9999px;
      background: rgb(249 115 22);
      animation: app-loading-sweep 1.45s ease-in-out infinite;
    }

    @keyframes app-loading-sweep {
      0% {
        left: -32%;
      }
      50% {
        left: 100%;
      }
      100% {
        left: -32%;
      }
    }
  `,
})
export class App implements OnInit {
  private readonly ngSelectConfig = inject(NgSelectConfig);
  protected readonly loadingService = inject(LoadingService);

  constructor() {
    this.ngSelectConfig.notFoundText = 'Nenhum resultado encontrado';
    this.ngSelectConfig.loadingText = 'Carregando...';
    this.ngSelectConfig.placeholder = 'Selecione';
  }

  ngOnInit() {
    Aos.init({ duration: 800, once: true });
  }
}
